import { render, staticRenderFns } from "./supportConference.vue?vue&type=template&id=bd886662"
import script from "./supportConference.vue?vue&type=script&lang=js"
export * from "./supportConference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports